import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";
import { Input } from "../components/ui/input";
import { Search } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cats, setCats] = useState([]);
  const [params, setParams] = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  const [cat, setCat] = useState(params.get("category") || "all");
  const [sort, setSort] = useState("featured");

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data));
  }, []);

  useEffect(() => {
    const query = new URLSearchParams();
    if (cat !== "all") query.set("category", cat);
    if (q) query.set("q", q);
    api.get(`/products?${query.toString()}`).then((r) => {
      let list = r.data;
      if (sort === "price-low") list = [...list].sort((a, b) => a.price - b.price);
      if (sort === "price-high") list = [...list].sort((a, b) => b.price - a.price);
      if (sort === "name") list = [...list].sort((a, b) => a.name.localeCompare(b.name));
      setProducts(list);
    });
  }, [q, cat, sort]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-8 py-16" data-testid="shop-page">
      <div className="mb-10">
        <p className="text-sm uppercase tracking-[0.2em] text-[#E65A28] mb-2 font-semibold">Shop</p>
        <h1 className="font-serif text-5xl md:text-6xl text-[#0A192F]">All Products</h1>
        <p className="mt-3 text-[#666] max-w-xl">Explore our full range of Ayurvedic personal care essentials.</p>
      </div>

      <div className="flex flex-col md:flex-row gap-4 mb-10">
        <div className="relative flex-1">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-[#666]" />
          <Input
            placeholder="Search products..."
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="pl-11 h-12 rounded-full bg-white border-[#0A192F]/10"
            data-testid="shop-search-input"
          />
        </div>
        <Select value={cat} onValueChange={setCat}>
          <SelectTrigger className="md:w-56 h-12 rounded-full bg-white" data-testid="shop-category-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Categories</SelectItem>
            {cats.map((c) => <SelectItem key={c.slug} value={c.slug}>{c.name}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={sort} onValueChange={setSort}>
          <SelectTrigger className="md:w-48 h-12 rounded-full bg-white" data-testid="shop-sort-select">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="featured">Featured</SelectItem>
            <SelectItem value="price-low">Price: Low to High</SelectItem>
            <SelectItem value="price-high">Price: High to Low</SelectItem>
            <SelectItem value="name">Name (A-Z)</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {products.length === 0 ? (
        <p className="text-center text-[#666] py-20">No products found.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {products.map((p) => <ProductCard key={p.product_id} product={p} />)}
        </div>
      )}
    </div>
  );
}
